import {ERoleSystem} from '@/api/enums/role';
import {ERoleSource} from '@/api/enums/roleSource';

export const translationRoleSystem: Record<ERoleSystem, string> = {
  [ERoleSystem.GUEST]: 'Гость',

  [ERoleSystem.ADMIN]: 'Администратор',

  [ERoleSystem.USER]: 'Пользователь',
};

export const translationRoleSource: Record<ERoleSource, string> = {
  [ERoleSource.MANUAL]: 'Вручную',
  [ERoleSource.KEYCLOAK]: 'Keycloak',
};
